import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'; // Replaces ClockIcon
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
// import { OnlineNotification } from './OnlineNotification';
import './TasksListMain.scss';

const TasksListMain = ({ taskRecord, onNameClick, activeName }) => {
  // Sort the taskRecord by credits (Turn), and move rows with non-empty status to the bottom
  const sortedRecords = [...taskRecord].sort((a, b) => {
    if (a.status === '' && b.status !== '') return -1;
    if (a.status !== '' && b.status === '') return 1;
    return a.credits - b.credits;
  });

  //console.dir('taskRecord:', taskRecord);
  const handleRowClick = name => {
    onNameClick(name);
  };

  const renderStatus = status => {
    if (status.includes('working')) {
      return (
        <span className="status-busy">
          Busy <AccessTimeOutlinedIcon className="status-icon" />
        </span>
      );
    } else if (status.includes('break')) {
      return (
        <span className="status-break">
          Break <AccessTimeOutlinedIcon className="status-icon" />
        </span>
      );
    }
    return null;
  };

  return (
    <div className="tasks-list-container">
      <div className="header">
        <span className="title"></span>
      </div>

      <div className="content">
        <table className="tasks-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Turn</th>
              <th>Status</th>
              <th>Notify</th>
            </tr>
          </thead>
          <tbody>
            {sortedRecords.map((record, index) => (
              <tr
                key={index}
                className={record.name === activeName ? 'row-active' : ''}
                onClick={() => handleRowClick(record.name)}
              >
                <td className="name-cell">{record.name}</td>
                <td className="turn-cell">
                  <Chip
                    label={record.credits}
                    // color="primary"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      padding: '0px',
                      backgroundColor: 'rgba(45, 191, 224, 0.36)', // Blue with 20% opacity
                    }}
                  />
                </td>
                <td className="status-cell">{renderStatus(record.status)}</td>
                <td className="notify-cell">
                  ...
                  {/* <OnlineNotification empUserId={record.empUserId} /> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

TasksListMain.propTypes = {
  taskRecord: PropTypes.array.isRequired,
  onNameClick: PropTypes.func.isRequired,
  activeName: PropTypes.string,
};

export default TasksListMain;
